<template>
  <generic-modal :title="$t('profile')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column is-three-fifths">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_default"
              v-model="meta.is_default"
            />
            <label for="chk_is_default">{{ $t("is default") }}</label>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("wsdl url") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.wsdl_url"
            placeholder="https://epaytestvisanet.com.gt/?wsdl"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("sale message type") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.sale_message_type"
                placeholder="0200"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("reverse message type") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.reverse_message_type"
                placeholder="0400"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("void message type") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.void_message_type"
                placeholder="0202"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("timeout limit (miliseconds)") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.timeout_limit"
                placeholder="60000"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("pos entry mode") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.pos_entry_mode"
                placeholder="012"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("terminal id") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.terminal_id"
                placeholder="77788881"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("merchant") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.merchant"
                placeholder="00575123"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("gateway ip") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.gateway_ip"
                placeholder="190.111.1.198"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("audit number") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.audit_number"
                placeholder="000061"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-clock-o"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("merchant user") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.merchant_user"
            placeholder="76B925E..."
          />
          <span class="icon is-small is-left">
            <i class="fa fa-clock-o"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">{{ $t("merchant password") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.merchant_password"
            placeholder="DD179..."
          />
          <span class="icon is-small is-left">
            <i class="fa fa-clock-o"></i>
          </span>
        </p>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, post, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      provider_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(profile) {
      let v = this;
      v.set_initial_state();
      console.log(profile);
      Object.keys(profile).map((k) => {
        v.meta[k] = profile[k];
      });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      v.$emit("success", profile);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        name: "",
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
